enum InventoryModuleApiSuffixModels {
  SUPPLIER_AUTOCOMPLETE = 'suppliers/autocomplete',
  UX_BRANDCATEGORIES = 'ux/brandCategories',
  PRODUCTS = 'products',
  PLANT = 'warehouses',
  LOCATION_ROWS = 'location-rows',
  LOCATION_SHELFS = 'location-shelfs',
  LOCATION_SHELFS_BINS = 'location-shelfs-bins',
  LOCATION_MERGE = 'location-bin',
  LOCATION_BIN_UNMERGE = 'location-bin-unmerge',
  LOCATION_BIN_MERGE = 'location-bin-merge',
  LOCATION_BIN_DETAIL = 'location-bin-detail',
  LOCATION_SHELF = 'location-shelf',
  LOCATION_SHELF_BIN = 'location-shelf-bin',
  WAREHOUSE_ADDRESS = 'warehouseaddress',
  ITEM_SUPPLY_STATUS = 'itemssupplystatus',
  UX_ITEM_SUPPLY_STATUS = 'ux/itemstatus',
  DEALER_STOCK_ORDER_EXPORT = 'Dealer-Stock-Order-Collections-export',
  DEALER_ORDER_STATUS = 'dealerorderstatus',
  UX_DEALER_ORDER_STATUS = 'ux/dealerorderstatus',
  INTERBRANCH_ORDER_STATUS = 'interbranchorderstatus',
  UX_INTERBRANCH_ORDER_STATUS = 'ux/interbranchorderstatus',
  ITEM_TYPES = 'itemtypes',
  ITEM_PRICE_TYPES = 'itemspricetypes',
  UX_ITEM_TYPES = 'ux/itemtypes',
  JOB_ORDER_STATUS = 'joborderstatus',
  UX_JOB_ORDER_STATUS = 'ux/joborderstatus',
  UX_PACKIN_DASHBOARD_STATUS = 'ux/PackingDashboard-Status',
  SUPPLIERS = 'suppliers',
  SUPPLIER_RETURN = 'supplierreturn',
  SUPPLIER_RETURN_FILE_UPLOAD = 'supplierreturn/document-upload',
  SUPPLIER_RETURN_NEW_DOCUMENT = 'supplier-return-request-new-document',
  SUPPLIERRETURN_DELETE_SERIAL_NUMBER = 'supplierreturn/delete/serial-number',
  UX_SUPPLIERRETURNSTATUS = 'ux/supplierreturnstatus',
  SUPPLIER_RETURN_RELATEDITMES = 'supplierreturn/related/items',
  SUPPLIER_RETURN_RECEIVING_RELATEDITMES = 'supplierreturn/receiving/relateditems',
  SUPPLIER_RETURN_RECEIVING = 'supplierreturn/receiving',
  SUPPLIER_RETURN_RECEIVING_VIEW = 'supplierreturn/receiving/view',
  UX_SUPPLIERS = 'ux/suppliers',
  UX_SUPPLIER_RETURN ='ux/supplierreturn-supplier',
  TECHNICIAN_ORDER_STATUS = 'technicianorderstatus',
  UX_TECHNICIAN_ORDER_STATUS = 'ux/technicianorderstatus',
  VARIANCE_INVESTIGATION_STATUS = 'varianceinvestigationstatus',
  UX_VARIANCE_INVESTIGATION_STATUS = 'ux/varianceinvestigationstatus',
  WARRANTY_STATUS = 'warrantystatus',
  UX_WARRANTY_STATUS = 'ux/warrantystatus',
  ITEM = 'items',
  ITEM_PRICE = "itemprices",
  ITEM_PRICE_ENABLE_DISABLE = "itemprices/enabledisable",
  ITEM_PRICE_BY_ITEM = "itemprices/byItem",
  ITEM_PRICE_BULK_UPDATE = "itemprices-bulkupdate",
  UX_ITEM_SEARCH_BY_CODE = 'ux/items/searchbycode',
  UX_ITEM_CATEGORY = 'ux/itemcategories',
  UX_ITEM_BRAND = 'ux/itembrands',
  UX_ITEM_SEARCH_BY_NAME = 'ux/items/searchbyname',
  UX_ITEM_PRICE_TYPE = 'ux/itemspricetypes/type',
  UX_ITEM = 'ux/items',
  UX_ITEM_DESCRIPTION = 'ux/items-stockcode-description',
  ITEM_PRICETYPE = 'itemspricetypes',
  UOM = 'ux/unitomMeasurements',
  ITEM_STATUS = 'itemstatus',
  ITEM_BRAND = 'itembrands',
  ITEM_BRAND_ID = 'ux/itembrands',
  ITEM_CATEGORY = 'item-categories',
  TIME_FRAME_CONFIG = 'audit-cycle-timeframe/config',
  UX_ITEM_CATEGORIES = 'UX/item-categories',
  UX_ITEM_CATEGORIES_MAPPING = 'ux/item-categories-mapping',
  ITEM_CATEGORY_MAPPING = 'item-categories-mapping',
  ALLOCATION_CONFIG = 'audit-cycle-allocation-config',
  AUDIT_CYCLE_HIGH_RISK_STOCK_CONFIG = 'audit-cycle-high-risk-stock-config',
  AUDIT_CYCLE_HIGH_RISK_CONFIG_DETAILS = 'audit-cycle-high-risk-stock-config/details',
  AUDIT_CYCLE_HIGH_RISK_STOCK_CONFIG_VALIDATE = 'audit-cycle-high-risk-stock-config/Validate',
  ITEM_MAPPING_DETAIL = 'item-categories-mappingdetail',
  ITEM_CATEGORY_MAPPING_PUT = 'item-categories/item-mapping',
  ITEM_CATEGORYBRANDPRICE = 'ux/dropdowns/items',
  TRANSFER_REQUEST = 'interbranchstockorders',
  STORAGE_LOCATION = 'storagelocations',
  UX_STORAGE_LOCATION = "ux/storagelocations",
  UX_STORAGE_LOCATIONS = "ux/storage-locations",
  WAREHOUSELOCATION = 'locations/warehouse',
  LOCATION = 'locations',
  RECEIPTING = 'orderreceipts',
  RECEIVED_RTR_SAVE = 'receiving-rtr-save',
  RTR_SUPPLIER_RETURN_GENERATE_PDF  = 'RTR-supplier-return-generate-pdf',
  INTERTECHNICIANORDER = 'technicianorders',
  INITIATE_LIST = 'interbranchstockorders/initiate/requestorders',
  UX_WAREHOUSE = "ux/warehouses",
  UX_WAREHOUSE_STOCK_TAKE_INITIATION ="ux/warehouse-stock-take-initiation-warehouses",
  UX_REQUISITION_WAREHOUSE = "ux/requisition-configuration-Warehouses",
  UX_WAREHOUSE_BRANCH ='ux/warehouses-user-branch',
  KIT_CONFIGURATION_LIST = 'kit-configuration',
  KIT_CONFIGURATION_DETAILS = "kit-configuration/details",
  KIT_CONFIGURATION_STATUS = "kit-configuration/enable-disable",
  KIT_CONFIGURATION_ITEM = "kit-configuration-item",
  KIT_CONFIGURATION_EXPORT = 'kit-configuration-export',
  UX_KIT_NAME = "ux/kit-configuration/code-name",
  UX_KIT_TYPE = "ux/kit-type",
  UX_KIT_COMMENT_TYPE = "ux/kit-comment-type",
  UX_KIT_TYPE_STATUS = "ux/kit-type-status",
  UX_LOCATION_SHELF = 'ux/location-shelf',
  TRANSFER_INITIATE_REQUEST = 'interbranchstockorders/initiate/request',
  TRANSFER_INITIATE_ORDER = 'interbranchstockorders/initiate/order',
  TRANSFER_INITIATE_DELETE = 'interbranchstockorderitem/initiate/request',
  UX_ITEM_CODES = "ux/items/codes",
  ITEM_CODES = "items/codes",
  INTERTECHNICIANORDER_VIEW_DETAILS = 'technicianorders/',
  REPAIRREQUEST = 'Repair/request',
  TECHNICIAN_ORDER = "technicianorders",
  PURCHASEORDER = "purchaseorders",
  UX_PURCHASEORDER_SEARCH = "ux/purchaseorders/search",
  UX_ORDER_RECEIPT_NUMBER_SEARCH = "ux/orderreceipts/search",
  PURCHASEORDER_RELATEDITEMS = "purchaseorders/items",
  PURCHASEORDER_CONSOLIDATE = "purchaseorders/consolidate",
  INTRANSIT_DETAILS = "orderreceipts-intransit/details",
  INTRANSIT_DETAILS_IBT ="orderreceipts-OrderReceipt-ibt-details",
  TECHNICIAN_FAULT = "orderreceipts-technician-fault",
  PURCHASEORDER_DETAIL = "purchaseorders",
  STOCK_ORDERS = "stockorders",
  STOCK_ORDER_TYPES = "ux/stock-order-types",
  UX_STOCK_ORDER = "ux/stockorders",
  STOCK_ORDERS_ITEMS = "stockOrderitems",
  ITERTECHNICIAN_TRANSFER = "intertechniciantransfers",
  ORDER_TYPES = "ux/orderTypes",
  INTERTECHNICIAN_TRANSFER = "intertechniciantransfers",
  INTERTECHNICIAN_TRANSFER_VIEW = "intertechniciantransfers/ViewDetails",
  ORDER_RECEIPTS = "orderreceipts",
  ORDER_RECEIPTS_SAVE_AS_DRAFT = "orderreceipts/save-as-draft",
  ORDER_RECEIPTS_INTRANSIT = "orderreceipts/intransit",
  ORDER_RECEIPT_DETAILS = "orderreceipts/details",
  RECEIVING_IBT_SAVE = 'receiving-ibt-save',
  UX_LOCATION = "ux/locations",
  UX_LOCATION_ROWS = "ux/location-rows",
  ORDER_DETAILS = "orderrecepts/details",
  STOCK_ORDER_APPROVAL_LIST = 'stockordersapproval',
  STOCK_ORDER_APPROVAL_UPDATE = 'stockorders/approval',
  UX_RQNSTATUS = 'ux/rqnstatus',
  CREDIT_NOTE = 'creditnote',
  CREDIT_NOTE_FILE_UPLOAD = 'creditnotefileupload',
  UX_REPAIRREQUEST_SEARCH = "ux/repairrequests/search",
  UX_SUP_RETURN_NUMBER_SEARCH = "ux/supplierreturn/search",
  REPAIRREQUEST_RELATEDITEMS = "repairrequests/items",
  UX_ISSUINGPLANT = "ux/warehousesPlant",
  PICKER_JOBS = "pickerjobs",
  PICKER_JOBS_DETAILS = "pickerjobs/details",
  TRANSFER_REQUEST_PACKING_JOB_DETAILS = 'Transfer-Request-Packing-job/details',
  INTERBRANCH_STOCK_DETAILS = "inter-branch-stockorder-details",
  RECEIVING_IBT_DETAILS ='Receiving-Ibt-details',
  UX_ORDER_RECEIPTS_SEARCH = "ux/orderreceipts/search",
  PICKER_BARCODE = "pickerjobs/barcode",
  VARIANCE_ESCLATION = "varianceinvestigationrequests",
  VARIANCE_ESCLATION_DETAILS = "varianceinvestigationrequestsList",
  UX_PICKER_JOBS = "ux/pickerjobs",
  UX_ITEM_SEARCH_BY_NAME_CATEGORY = "ux/items/searchbycategory",
  UX_SUPPLIERS_BY_NAME = 'suppliers/autocomplete',
  UX_SUPPLIER_SEARCH_BY_REPAIR_REQUEST = "ux/suppliers/search",
  Warehouse_Exist = "warehouses/exist-details",
  INTERBRANCH_STOCK_ORDER = "inter-branch-stockorder",
  INTERBRANCH_STOCK_ORDER_APPROVE = "inter-branch-stockorder-approve",
  INTERBRANCH_STOCK_ORDER_APPROVE_EXPORT ='inter-branch-stockorder-approve-export',
  INTERBRANCH_STOCK_ORDER_EXPORT ='inter-branch-stockorder-request-export',
  ITEMS_PROCESS_FILES = "items/process-file",
  ITEMS_IMPORT = 'items/import',
  WAREHOUSE_STOCK_TAKE_MANAGER = 'warehouse-stock-takes-manager',
  WAREHOUSE_STOCK_TAKE_MANAGER_EXPORT ='warehouse-stock-takes-manager-export',
  WAREHOUSE_STOCK_TAKE_MANAGER_VERIFY = 'warehouse-stock-take-manager-verify',
  WAREHOUSESTOCKTAKEAPPROVAL = 'warehouse-stock-take-approval',
  WAREHOUSESTOCKTAKESTATUS = 'ux/warehouse-stock-takestatus',
  WAREHOUSE_STOCK_PROCESS_MANAGER = 'stock-take/process-manager',
  WAREHOUSE_STOCK_PROCESS_MANAGER_DETAILS = 'stock-take/process-manager-details',
  UX_WAREHOUSE_STOCK_PROCESS = 'ux/stock-take/process',
  WAREHOUSE_STOCK_PROCESS_DETAILS = 'stock-take/process-details',
  WAREHOUSE_STOCK_PROCESS_FINAL_DETAILS = 'stock-take/process-final-details',
  WAREHOUSE_STOCK_PROCESS_SCANNING_DETAILS = 'stock-take/process-scanning-details-manager',
  WAREHOUSE_MANAGER_FINAL_DETAILS = 'stock-take/process-consolidated-details',
  WAREHOUSE_STOCK_PROCESS_SCANNING_DETAILS_UPDATE = 'stock-take/process-scanning-details',
  WAREHOUSE_STOCK_PROCESS_UPDATE = 'stock-take/process-status-update',
  UX_STORAGE_LOCATION_WAREHOUSE = "ux/storage-location-warehouse",
  UX_PICKING_ORDER_ISSUE_TECH_LOCATION = "ux/picking-order-issuing-tech-location",
  UX_PICKED_ORDER_ISSUE_TECH_LOCATION = "ux/picked-order-issuing-tech-location",
  UX_PICKING_ORDER_REQUESTING_LOCATION = "ux/picking-order-requesting-location",
  UX_PICKED_ORDER_REQUESTING_LOCATION = "ux/picked-order-requesting-location",
  STOCK_INITIATE_VIEW = 'warehouse-stock-take',
  WAREHOUSE_STOCK_TAKE_JOBS = 'warehouse-stock-take-jobs',
  WAREHOUSE_STOCK_TAKE_JOB_DETAILS = 'warehouse-stock-take-jobs-details',
  WAREHOUSE_STOCK_TAKE_JOBS_EXPORT ='warehouse-stock-take-jobs-export',
  WAREHOUSE_STOCK_TAKE_JOBS_STOCK_AVAILABLITY_IN_STAGING_DISPATCH_LOCATION = 'warehouse-stock-take-jobs/stock-availablity-in-staging-dispatch-location',
  WAREHOUSE_STOCK_TAKE_JOBS_DETAILS_INSERT = 'warehouse-stock-take-jobs-details-insert',
  WAREHOUSE_STOCK_TAKE_JOBS_STATUS_UPDATE = 'warehouse-stock-take-jobs-Status-Update',
  UX_WAREHOUSE_STOCK_TAKE_JOBS_LOCATIONS = 'ux/warehouse-stock-take-jobs/locations',
  LEAD_ITEM_INFO = "item/info",
  STOCK_MAINTENANCE_NEW = "stockmaintenance/new",
  STOCK_MAINTENANCE = "stock-maintenance",
  STOCK_MAINTENANCE_CONSOLIDATE = 'stock-maintenance/consolidate',
  STOCK_MAINTENANCE_PRODUCT_WAREHOUSE = 'stock-maintenance-product-warehouse',
  STOCK_MAINTENANCE_PRODUCT_THRESHOLD = 'stock-maintenance-product-threshold',
  STOCK_MAINTENANCE_SKILL_MAPPING = 'stock-maintenance/skill-mapping',
  STOCK_MAINTENANCE_UX_PRODUCT_WAREHOUSE = 'stock-maintenance/ux/product-warehouse',
  UX_COST_SOURCE = 'ux/cost_source',
  UX_WARRANTY_PERIODS = 'ux/warranty-periods',
  UX_SYSTEM_TYPE = 'ux/system-type',
  UX_COMPONENT_GROUP = 'ux/component-group',
  UX_COMPONENT = 'ux/component',
  UX_ITEMBRANDS = 'ux/itembrands',
  UX_ITEM_CONDITION = 'ux/item-condition',
  UX_ITEM_OWNER_SHIP_TYPE = 'ux/item-owner-ship-type',
  UX_REPAIRREQUESTS_SEARCH_PURCHASE_ORDER = 'ux/repairrequests/search-purchase-order',
  UX_REPAIRREQUESTS_SEARCH = 'ux/repairrequests/search',
  ORDERRECEIPTS_PURCHASE_RETURN_RELATED_DETAILS = 'orderreceipts/purchase-return-related-details',
  SUPPLIERRETURN_SERIAL_NUMBERS = 'supplierreturn/serial-numbers',
  SUPPLIERRETURN_RELATED_DETAILS = 'supplierreturn/related-details',
  UX_SUPPLIERRETURNSTATUS_SUPPLIERRETURNACTIONTYPES = 'ux/supplierreturnstatus/supplierreturnactiontypes',
  UX_SUPPLIER_RETURN_SEARCH_ADDRESS = 'ux/supplieraddress/search',
  UX_ITEMS_CODES = 'ux/items/codes',
  UX_NEW_ITEMS_CODES = 'ux/items/new',
  BRANDCATEGORIES_GETALL = "brandCategories-get-all",
  ITEM_PRICING_CONFIG = "item-pricing-config",
  ITEM_PRICING_CONFIG_DETAILS = 'item-pricing-config-details',
  STOCK_ITEM_LOOKUP = "stockitem-lookup",
  STOCK_ITEM_SITE_TYPE = "stockitem/sitetypes",
  UX_PRICE_LIST_CODE = 'ux/items/pricelistcode',
  ITEM_PRICING_CONFIG_PRICE_LIST_CODE_VERIFY = "item-pricing-config/price-list/code",
  MASTER_ITEM_PRICE_LIST = 'items/master/price',
  MASTER_ITEM_PRICE_VIEW = 'items/master/pricing/view',
  BIN_MANAGEMENT = 'bins',
  BIN_MANAGEMENT_BY_WAREHOUSE_LOCATION = 'bins-warehouse-location',
  BIN_MANAGEMENT_AUTO_LIST = 'bins-auto-list',
  UX_TIMEFRAMETYPE = 'ux/timeframe-type',
  UX_ITEM_BRAND_MODEL = 'ux/item-brand-model',
  ITEM_BRAND_MODEL = 'item-brand-model',
  ITEM_BRAND_MODEL_SEARCH = 'item-brand-model-search',
  UX_ITEM_BRAND_SEARCH = 'ux/itembrands/search',
  WAREHOUSE_BY_USER = 'warehouses/user',
  UX_TECHNICIAN = "intertechniciantransfers/ux/technician",
  CYCLE_COUNT = 'cycle-count',
  CYCLE_COUNT_CONFIG_EXPORT = 'cyclecount-config-export',
  CYCLE_COUNT_MANAGER_VIEW_LIST = 'cycle-count-manager-view-list',
  CYCLE_COUNT_MANAGER_VIEW_LIST_EXORT = 'cycle-count-manager-view-list-export',
  CYCLE_COUNT_MANAGER_VIEW_DETAILS = 'cycle-count-manager-view-details',
  CYCLE_COUNT_MANAGER_REPORT = 'cycle-count-manager-report',
  CYCLE_COUNT_EXPORT ='cycle-count-export',
  CYCLE_COUNT_CONFIG = 'cyclecount-config',
  CYCLE_COUNT_CONFIG_WAREHOUSE = 'cyclecount-config/warehouse',
  CYCLE_COUNT_CONFIG_DETAILS = 'cyclecount-config-details',
  PURCHASE_ORDER_ITEMS = "purchaseorderitems-order-number",
  WASTE_DISPOSAL_COMPANIES = "waste-disposal-companies",
  WASTE_DISPOSAL_COMPANIES_EXPORT ='waste-disposal-companies-export',
  ORDERRECEIVE_NEW = "orderreceipts-new",
  ORDERRECEIVE_TECHNICIAN = "orderreceipts-technician",
  ORDERRECEIVE_SUPPLIERRETURN = "orderreceipts-supplier-return",
  ORDERRECEIV_INTRANSIT = "orderreceipts-intransit",
  WASTE_DISPOSAL = "waste-disposal",
  WASTE_DISPOSAL_EXPORT = 'waste-disposal-export',
  WASTE_DISPOSAL_VIEW = "waste-disposal/WasteDisposalView",
  WASTE_DISPOSAL_GET = "waste-disposal/WasteDisposalAndRelatedItems",
  WASTE_DISPOSAL_ADD_EDIT = "waste-disposal",
  UX_WASTE_DISPOSAL_COMPANIES = "ux/waste-disposal-companies",
  WASTE_DISPOSAL_ASSETS = "waste-disposal/relateditems",
  ORDERRECEIVE_TECHNICIAN_FAULTY = "orderreceipts-technician-faulty",
  RECEVING_RTR_DETAILS = "receiving-rtr-details",
  ORDERRECEIVE_TECHNICIAN_GOODSRETURN = "orderreceipts-technician-goods-return",
  GOODSRETURN_EXPORT = 'goods-Return-export',
  VARIANCE_EXPORT='variance_exclation_export',
  STOCK_ADJUSTMENT_EXPORT = 'stock-adjustment-export',
  DISCREPANCY_EXPORT = 'Discrepancy-export',
  STOCK_MOVEMENT_STOCKONHAND_EXPORT  = 'stock-movement-StockOnHand-export',
  STOCK_MOVEMENT_SUMMARY_EXPORT  = 'stock-movement-summary-export',
  STOCK_MOVEMENT_EXPORT   = 'stock-movement-export',
  STOCK_MOVEMENT_AGEING_EXPORT  = 'stock-movement-ageing-export',
   STOCK_MOVEMENT_SAP_LOG  = 'stock-movement-log-export',
  WASTE_DISPOSAL_MANAGER = "waste-disposal-manager",
  WASTE_DISPOSAL_MANAGER_VIEW = "waste-disposal-manager/WasteDisposeManagerView",
  WASTE_DISPOSAL_APPROVAL = "waste-disposal-approval",
  WASTE_DISPOSAL_APPROVAL_EXPORT = 'waste-disposal-approval-export',
  WASTE_DISPOSAL_APPROVAL_VIEW = "waste-disposal-approval/View",
  WASTE_DISPOSAL_APPROVAL_SUBMIT = "waste-disposal-approval/submit",
  UX_WASTE_DISPOSAL_ACTION_TYPES = "ux/waste-diposal/action-type",
  CYCLE_COUNT_STAFF_VIEW = "cycle-count-staff-view-details",
  CYCLE_COUNT_SCANNED_SERIAL_NO = "cycle-count-stock-Scanned-serialnumbers",
  CYCLE_COUNT_BIN_DETAILS = "cycle-count-Location-Bin-details",
  CYCLE_COUNT_STOCK_TAKEN = "cycle-count-stock-taken",
  CYCLE_COUNT_ADD_ITEMS = "cycle-count-add-items",
  CYCLE_COUNT_STOCK_SAVE = "cycle-count-stock-save",
  ORDER_RECEIPT_FINAL_SUBMIT = 'orderreceipts-final-submit',

  PURCHASE_ORDER = "purchaseorders",
  UX_WAREHOUSES = 'ux/warehouses',
  UX_PURCHASEORDERS_BY_WAREHOUSE = 'ux/purchaseorders/by-warehouse',
  UX_TECHNICIAN_SEARCH = 'ux/technician/search',
  UX_SUPPLIERADDRESS_SEARCH = 'ux/supplieraddress/search',
  TECHNICIAN_STOCK_COLLECTION_CREATE = 'technician-stock-collection-create',
  TECHNICIAN_STOCK_COLLECTION_DELETE = 'technician-stock-collection',
  TECHNICIAN_STOCK_COLLECTION_DOCUMENT = 'technician-stock-collection-document',
  PURCHASEORDERS_FILEUPOLAD = 'purchaseorders/fileupload',
  DELIVERY_METHODS = "ux/deliverymethods",
  COLLECTION_LIST = "ux/purchase-Order/Collection-Types",
  WEREHOUSESTAFF_LIST = "stock-take/process",
  WEREHOUSE_PROCESSDETAILS = "stock-take/process-details",
  WEREHOUSE_PROCESSINITIATE = "stock-take/process-initiate",
  WEREHOUSE_LOCATIONS = 'ux/warehouse-stock-take/locations',
  WEREHOUSE_PROCESS_SCANNING = 'stock-take/process-scanning-details',
  WEREHOUSE_FINAL_DETAILS = 'stock-take/process-final-details',

  DOA_CONFIG_LIST = "doa-approval",
  DOA_CONFIG_VIEW = "doa-approval/View",
  DOA_CONFIG_TYPES = "ux/doa-approval/configtype",
  DOA_CONFIG_LEVELS = "ux/doa-approval/level",
  DOA_CONFIG_ROLES = "ux/roles",

  COMPONENT = 'component',
  COMPONENT_ID = 'ux/component',
  DECODER_ITEMS = 'decoder-items',
  DECODER_ITEMS_UPDATE = 'decoder-items/enable-disable',
  UX_DECODER_ITEMS = 'ux/decoder-items',
  SUB_CATEGORIES = 'system-type/sub-categories',
  STOCK_MANAGEMENT_COMPONENT_GROUP = "component-group",
  STOCK_MANAGEMENT_COMPONENT_GROUP_ID = "ux/component-group",
  STOCK_MANAGEMENT_SYSTEM_TYPE_LIST = "system-type",
  STOCK_MANAGEMENT_SYSTEM_TYPE_VIEW = "system-type/view",
  SYSTEM_TYPE_EXCEL = 'system-type-export-Excel',
  COMPONENT_GROUP_EXCEL = 'component-group-export-Excel',
  COMPONENT_EXCEL= 'component-export-Excel',
  ITEM_BRAND_EXCEL = 'itembrands-export-Excel',
  SYSTEM_TYPE_SUB_CATEGORY_EXCEL = 'system-type/sub-categories-export-Excel',
  ITEM_OBSOLETE_EXPORT= 'item-Obsolete-Config-export-excel',
  DOA_CONFIG_ADD_EDIT = "doa-approval",
  STOCK_SELLING_PRICE = "stock/selling-price",
  STOCK_SELLING_PRICE_DETAILS = "stock/selling-price-details",
  STOCK_SELLING_PRICE_HISTORY = "stock/selling-price-history",
  STOCK_SCHEDULING_SELLING_PRICE = "stock/schedule-selling-price",
  STOCK_SCHEDULING_JOBS = "stock/selling-price-job",
  STOCK_SCHEDULING_JOBS_DETAILS = "stock/selling-price-job/details/list",
  STOCK_SUB_CATEGORIES = 'ux/system-type/sub-categories',
  UX_SYSTEM_TYPES = "ux/system-type",

  STOCK_MANAGEMENT_LIST = 'stock-management',
  STOCK_MANAGEMENT_DETAILS = 'stock-management/details',
  STOCK_MANAGEMENT_BIN_DETAILS = 'stock-management/bin-location',

  REQUISITION_GET_DETAILS = 'requisition-request-approval',
  REQUISITION_EXPORT = 'requisition/requisition-export-Excel',
  REQUISITION_APPROVAL_EXPORT = 'requisition-request-approval-export',
  REQUISITION_SEARCH_ITEM = 'requisition/item',
  STOCKORDERS_DROPDOWN = 'ux/stockorders-Requisition',
  PICKING_ORDERS_DROPDOWN='ux/pickingorders-stockorders',
  PICKED_ORDERS_DROPDOWN='ux/pickedorders-stockorders',
  SCHEDULED_CUSTOMERS_ORDERS_DROPDOWN='ux/pickingorders-scheduledcustomer-stockorders',
  TECHNICIAN_ORDERS_DROPDOWN='ux/pickingorders-technician-stockorders',
  INTERBRANCH_ORDERS_DROPDOWN='ux/pickingorders-interbranch-stockorders',
  ACCEPTED_ORDERS_DROPDOWN='ux/pickingorders-accepted-stockorders',
  UX_STOCKORDERS = 'ux/stock-order-types',
  STOCKCODES_DROPDOWN = 'ux/items/bystockorders',
  REQUISITION_CANCEL = 'requisition/cancel',
  REQUISITION_LIST = 'requisition',
  REQUISITION_SAVE = 'requisition-save',
  UX_STOCK_ORDERS = 'ux/requisition-stockorder',
  UX_PRIORITY = 'ux/priority',
  STOCKORDER_ITEMS = 'requisition/stockorder-items',
  NEWSTOCK_ITEMS = 'requisition/newstock-items',
  ADD_REQUISITION_ITEM = 'requisition/item',
  STOCKORDERS_OTHERBRANCH = 'requisition-ibtransfer',
  INTERBRANCH_STOCK_ORDER_CREATE = 'inter-branch-stockorder/requisitions',
  REQUISITION_EDIT = 'requisition/edit',
  REQUISITION_DETAILS ='requisition-details',

  UX_PURCHASEORDER_WEREHOUSE = 'ux/purchaseorders/warehousebyPO',
  UX_PURCHASEORDER_SUPPLIER = 'ux/purchaseorders/supplierbyPO',
  UX_PURCHASEORDER_STOCKORDER = 'ux/purchaseorders/stockOrderbyPO',
  UX_PURCHASEORDER_ITEMS = 'ux/purchaseorders/ItemsbyPO',
  UX_ITEMS_BY_INTERBRANCH = 'ux/items/by-interbranch',
  UX_RECEIVINGCLERK_BY_INTERBRANCH = 'ux/receiving-clerk-interbranch',

  PURCHASEORDER_DETAILS = 'purchaseorders/detail',
  TECHNICIAN_STOCK_COLLECTION_PURCHASE_ORDER ='technician-stock-collectionPurchaseOrder',
  TECHNICIAN_JOB_DETAILS = 'technician-stock-collectionPurchaseOrder',
  UX_WAREHOUSE_SEARCH = "ux/warehouses/search",
  TECHNICIAN_STOCK_COLLECTION = 'technician-stock-collection/tab/item/details',
  TECHNICIAN_STOCK_COLLECTION_CANCEL = 'technician-stock-collection/Cancel',
  PURCHASEORDER_FILEUPLOAD = 'purchaseorders/fileupload',

  UX_PURCHASEORDER_BY_WEREHOUSE = 'ux/purchaseorders/warehouses',
  UX_RECEIVINGCLERK_BY_PURCHASEORDER = 'ux/receiving-clerk-purchase-order',
  GET_ADDRESS_FROM_AFRIGIS = 'afrigis/ux/address',
  PURCHASEORDERS_FILEDELETE = 'technician-stock-collection-document',
  ITEMOBSOLETECONFIG = 'item-Obsolete-Config',

  DAILY_STAGING_PAY_REPORT = 'staging-bay-report',
  RECEIVING_BARCODE_LIST = 'ux/staging-bay-report/receivingBarcodeByPO',
  STAGING_STOCK_CODE_LIST = 'ux/staging-bay-report/stockCodeByOrderNumber',
  STAGING_STOCK_INFO = 'staging-bay-report/stock-info',
  STAGING_STOCK_INFO_DETAILS = 'staging-bay-report/stock-info-Details',
  DAILY_STAGING_PAY_REPORT_INFO_EXPORT = 'staging-bay-report/stock-info-export',
  DAILY_STAGING_PAY_REPORT_DETAILS_EXPORT = 'staging-bay-report/stock-info-Details-export',
  DAILY_STAGING_PAY_EXPORT = 'staging-bay-report-export',

  INTER_BRANCH_STOCKORDERDETAIL = 'inter-branch-stockorder-detail',
  UX_PRIORITIES = 'ux/priorities',
  INTER_BRANCH_STOCKORDER_ITEM_AVAILABILITY = 'inter-branch-stockorder-item-availability',

  REQUISITION_CONFIGURATION = 'requisition-configuration',
  REQUISITION_CONFIGURATION_EXPORT = 'requisition-Configuration-export-Excel',
  REQUISITION_CONFIGURATION_FREQUENCY = 'requisition-configuration/ux/frequency',
  REQUISITION_CONFIGURATION_PERIODS = 'requisition-configuration/ux/periods',
  REQUISITION_CONFIGURATION_WEEKLY_PERIODS = 'requisition-configuration/ux/Requisition-Week-Periods',
  INTERBRANCH_STOCK_ORDER_ITEM_DELETE = 'interbranchstockorderitem',
  INTERBRANCH_REQUEST_BRANCH_MANAGER_APPROVER = 'inter-branch-stockorder-approver',
  INTERBRANCH_REQUEST_BRANCH_MANAGER_ACCEPTER = 'inter-branch-stockorder-acceptor',
  INTERBRANCH_STOCKORDER_COURIER_DETAILS = 'inter-branch-stockorder/courier-details',
  USER_DROPDOWN_LIST = 'ux/usersdropdown',

  PICKING_DASHBOARD = 'picking-dashboard',
  PICKING_ORDERS = 'picking-dashboard/picking-orders',
  PICKED_ORDERS = 'picking-dashboard/picked-orders',
  SCHEDULED_CUSTOMER_ORDERS = 'picking-dashboard/scheduled-customer-orders',
  DASHBOARD_TECHNICIAN_ORDERS = 'picking-dashboard/technician-orders',
  DASHBOARD_STOCK_ORDER = 'inter-branch-stockorder-dashboard-report',
  DASHBOARD_ACCEPTED_CUSTOMER = 'picking-dashboard/accepted-customer-orders',
  UX_DISPATCH_TRF_NUM = 'ux/PickedOrders-DispatchTRFNumbers',
  UX_STOCK_TRF_NUM  = 'ux/PickedOrders-StockTRFNumbers',
  UX_SALESREP   = 'ux/PickingCustomerOrder-Salesrep',
  INTER_STOCKORDER_DROPDOWN = 'ux/inter-branch-stockorder',
  INTERBRANCH_PICKED_BATCHE_COURIER = 'inter-branch-stockorder/picked-batch/courier',

  PICKING_DASHBOARD_VIEW = "picking-dashboard/view-stock-order",
  STOCK_ORDER_QUERY = 'stock-order-query',
  STOCK_ORDER_DETALS = 'stock-order-query/details',
  STOCK_ORDER_RESUBMIT = 'stock-order-query-resubmit',
  AUDIT_REPORT = 'stock-order-query/audit-report',

  EXCLUSION_LIST = 'exclusion-list',
  EXCLUSION_LIST_EXPORT = 'exclusion-list-export',
  GROUPS = "ux/groups",
  GROUP_ROLES = "ux/group-roles",
  PERMISSIONS = "ux/repository-permissions",
  REPOSITORY_PERMISSION_ROLES = "repository-permission-roles",
  REPOSITORY_DETAILS = "repository-permission-roles/details",
  REQUISITION_DETAILED_LIST = "requisition/detailed-list",
  REQUISITION = "Requisition",
  REQUISITION_IBT_ITEM_DETAILS = "requisition-ibtItemdetails",
  DIVISIONS = "ux/divisions",
  LOCATION_ROWS_DETAILS = "location-rows-details",
  ENABLE_DISABLE = "location-rows/enable-disable",
  LOCATION_ROWS_WAREHOUSE = "stock-in-bins-locationRows",
  LOCATION_SHELF_DETAILS = "location-shelf-detail",
  LOCATION_SHELF_BIN_DETAILS = "location-shelf-bin-detail",
  STOCK_IN_BINS_DETAILS = "stock-in-bins-details",
  STOCK_IN_BINS = "stock-in-bins",
  STOCK_IN_BINS_LINK = "stock-in-bins-Link",
  WAREHOUSE_ENABLE_DISABLE = "warehouses/enable-disable",
  LOCATION_SHELF_BIN_ENABLE_DISABLE = "location-shelf/bin/enable-disable",
  LOCATION_SHELF_BIN_ENABLE_DISABLES = "location-shelf/enable-disable",
  LOCATION_SHELF_BINS_ENABLE_DISABLE = "location-shelf-bin/enable-disable",
  LOCATION_CRM_SAP = "locations/location-crm-sap",
  STORAGE_LOCATIONS_CRM_SAP = "storagelocations/location-crm-sap",
  WAREHOUSE_LOCATION_ROWS = "location-rows-location",
  PURCHAING_GROUP = "ux/purchasing-groups",
  PURCHAING_ORGANIZATION = "ux/purchasing-organizations",
  INTERBRANCHSTOCKORDER_DETAILS = "inter-branch-stockorder/details",
  TECHINICIAN_STORAGE_LOCATION = 'storage-location',

  PACKER_JOBS_ASSIGN = 'packerjobs/assign',
  PICKERJOBS_ASSIGN = "pickerjobs/assign",
  PACKERJOBS_SCAN = "packerjobs/scan",
  PACKERS_JOBS_MANAGER_OVERRIDE = "packerjobs/manager-override",
  PICKERJOBS_JOB_ASSIGN = "pickerjobs/job-assign",
  STOCK_IN_BINS_SCAN = "stock-in-bins-scan",
  PICKERJOBS_SCAN = "pickerjobs/scan",
  TRANSFERJOBS_SCAN = "Transfer-Request-Packing-job/scan",
  UX_PICKERJOBS_BIN = "ux/pickerjobs/bin",
  UX_STOCK_BINS_BIN = "ux/stock-in-binsbin",
  UX_AVAILABLE_BINS = 'ux/stock-in-bins/available-bin',
  VARIANCE_TECH_AREA_MANAGER = "variance-escalation-tech-area-manager",
  VARIANCE_PICKER_JOBS = "pickerjobs/variance-escalation",
  GOODS_MOVEMENT_SAP_REQUEST ='SapCrmGoodsMovement/GetDetails',

  INVENTORY_STAFF_REGISTRATION = "inventory-staff-registration",
  INVENTORY_STAFF_REGISTRATION_EXPORT = "inventory-staff-registration-export-Excel",
  SEARCH_EMPLOYEE = "ux/inventory-staff-registration/search-empno",

  SERIAL_NUMBER_GENERATE = "serial-number-generator",
  STOCKCODEBARCODE_DETAILS ='stockcodebarcode-details',

  VARIANCE_ESCLATION_LIST = "variance-escalation",
  VARIANCE_ESCLATION_RESOLVE = "variance-escalation-resolve",
  UX_VARIANCE_NUMBER = "ux/variance-escalation-number",
  UX_FAULTY_PARTY = "ux/faulty-party",
  VARIANCE_REASONS = "ux/variance-reason",
  CYCLE_COUNT_VARIANCE_ESCLATION = "cycle-count/variance-escalation",

  STOCK_WRITE_UP = "stock-adjustment",
  STOCK_WRITE_UP_VARIANCE_ESCALATION= 'stock-adjustment/variance-escalation',
  STOCK_WRITE_OFF = "stock-adjustment",
  GRV_ESCALATION = 'goods-Return/variance-escalation',

  VARIANCE_SERIAL_NUMBER = "variance-escalation-serial-number",
  VARIANCE_ESCALATION_SCAN  ="variance-escalationManager-Scanned-Item_details",

  WARRANTY_PERIOD_CONFIG = 'warranty-period-config',
  WARRANTY_PERIOD_STOCK_TYPES = 'ux/stock-types',

  CYCLE_COUNT_DETAILS = 'cycle-count-details',
  CYCLE_COUNT_AVAILABLE_ROWS = 'ux/cycle-count-Item-Rows',
  CYCLE_COUNT_SCAN_ITEMS = 'cycle-count-scan',
  CYCLE_COUNT_ITEM_UNLOCK = 'cycle-count-item-unlock',
  CYCLE_COUNT_ITEM_TO_SCAN = 'cycle-count-Item-to-Scan',
  CYCLE_COUNT_ITEM ='cycle-count-item',
  CYCLE_COUNT_ITEMS_BIN_DETAILS = 'cycle-count-items-bin-details',
  CYCLE_COUNT_NEXT_ITEMS_DETAILS= 'cycle-count-Next-items-details',
  CYCLE_COUNT_TAKES_ITERATION_PROCESS = 'cycle-count-iteration-process',

  WAREHOUSE_STOCK_TAKE_STAFF = 'warehouse-stock-take-staff',
  WAREHOUSE_STOCK_TAKE_STOCK_DETAILS = 'warehouse-stock-take-staff-stock-details',
  WAREHOUSE_STOCK_TAKE_SCAN = 'warehouse-stock-take-staff-stock-scan',
  WAREHOUSE_STOCK_TAKE_STAFF_CONSUMABLE = 'warehouse-stock-take-staff-consumable',
  WAREHOUSE_NEXT_STOCK_CODE = 'warehouse-stock-take-staff-next-stock',
  WAREHOUSE_STOCK_TAKE_STAFF_ITERATION = 'warehouse-stock-take-staff-iteration',
  WAREHOUSE_STOCK_TAKE_SERIAL_CODE = 'warehouse-stock-take-staff-stock',
  WAREHOUSE_STOCK_TAKE_LOCK_UNLOCK = 'warehouse-stock-take-staff-stock-lock',

  SUPPLIER_RETURN_SERIAL_NUMBER_UPDATE = 'supplierreturn/serial-number',
  CYCLE_COUNT_SCHEDULE = 'cyclecount-schedule',
  CYCLE_COUNT_SCHEDULE_EXPORT ='cyclecount-schedule-export',

  PICKERJOBS_MANAGER_OVERRIDE = 'pickerjobs/manager-override',

  CYCLE_COUNT_VARIANCE_REPORTS = 'cycle-countvariance-report',
  CYCLE_COUNT_VARIANCE_REPORTS_DETAILS = 'cycle-count-variance-report-details',
  CYCLE_COUNT_MANAGER_ACTION = 'cycle-count-manager-action',

  UX_GOODS_RETURN = 'ux/goods-Return',
  UX_ORDER_RECEIPT_NUMBER_SEARCHS = 'ux/orderreceiptnumber/search',

  UX_RECEIVING_CLERKS = 'ux/receiving-clerk-technician',
  ITEM_IMAGES = 'item-images',

  WAREHOUSE_STOCK_LIMIT_CONFIG = 'stock-limit-config',
  ALLOCATION_CONFIG_DETAILS = 'audit-cycle-allocation-config/details',
  ALLOCATION_CONFIG_VALIDATE = 'audit-cycle-allocation-config/Validate',
  STOCK_LIMIT_CONFIG_EXPORT ='stock-limit-config-export',
  AUDIT_CYCLE_CONFIG_EXPORT  = 'audit-cycle-high-risk-stock-config-export',
  AUDIT_CYCLE_ALLOCATION_CONFIG_EXPORT ='audit-cycle-allocation-config-export',

  STOCK_BALANCE_SERIAL = 'stock-balance/serial',
  AUDIT_CYCLE_CONFIG_TYPE = 'ux/audit-cycle-config-type',
  AUDIT_CYCLE_CONFIG_SUB_TYPE = 'ux/audit-cycle-config-subtype',
  UX_TECHNICIAN_STORAGE_LOCATION = 'ux/technician-storage-location',
  UX_PICKER = 'ux/picking-dashboard/inventoryStaff',
  UX_TECHNICIAN_BY_LOCATION = 'ux/technician/by-location',
  AUDIT_CYCLE_COUNT = 'audit-Cycle-Count',
  AUDIT_CYCLE_COUNT_JOB = 'audit-Cycle-Count-jobs',
  AUDIT_CYCLE_COUNT_ITEM_DELETE = 'audit-Cycle-Count-item-delete',
  AUDIT_CYCLE_COUNT_STATUS_UPDATE = 'audit-Cycle-Count-Status-Update',
  AUDIT_CYCLE_COUNTHIGHRISKITEM = 'audit-Cycle-CountHighRiskItem',
  AUDIT_CYCLE_COUNT_STOCK_LIMIT_CONFIG = 'audit-Cycle-Count-stock-limit-config',
  AUDIT_CYCLE_COUNT_EXPORT = 'audit-Cycle-Count-export',
  GRV_LIST_DETAILS = 'goods-Return/automatedGRVlist',
  GRV_DETAILS = 'goods-Return/automatedGRVDetails',

  PICKEDJOBS_ASSIGN = 'pickedjobs/assign',
  PICKING_CANCELLING_ORDER = 'picking-dashboard/cancelling-order',
  PICKEDJOBS_ITEM_SCAN = 'pickedjobs/Item-scan',

  PACKERJOBS_REASSIGN = 'packerjobs/Reassign',
  STOCK_ADJUSTMENT = 'stock-adjustment',
  STOCK_ADJUSTMENT_DOCUMENTS = 'stock-adjustment/documents',
  STOCK_ADJUSTMENT_ASSIGN_NEWBIN = 'stock-adjustment-assign-newbin',
  UX_STOCK_ADJUSTMENT_DOCUMENT_TYPE = 'ux/stock-adjustment/document-type',
  UX_STOCK_ADJUSTMENT_ACTION_TYPE = 'ux/stock-adjustment/action-type',
  STOCK_ADJUSTMENT_APPROVAL = 'stock-adjustment/approval',

  AUDIT_CYCLE_COUNT_DETAILS_LIST = 'audit-Cycle-Count-detail-list',
  AUDIT_CYCLE_COUNT_DETAILS = 'audit-Cycle-Count-detail',
  AUDIT_CYCLE_COUNT_ITEM = 'audit-Cycle-Count-item',
  AUDIT_CYCLE_COUNT_SCAN = 'audit-Cycle-Count-scan',
  AUDIT_CYCLE_COUNT_STATUS_DETAILS = 'audit-Cycle-Count-status-details',
  AUDIT_CYCLE_COUNT_STOCK = 'audit-Cycle-Count-Stock',
  AUDIT_CYCLE_COUNT_ITEMS_ADD = 'audit-Cycle-Count-items-add',
  AUDIT_CYCLE_COUNT_ITERATION_PROCESS = 'audit-Cycle-Count-iteration-process',
  AUDIT_CYCLE_COUNT_COMPLETE_CURRENT_STOCK = 'audit-Cycle-Count-Complete-Current-stock',

  AUDIT_CYCLE_COUNT_MANAGER = 'audit-Cycle-Count-manager',
  AUDIT_CYCLE_COUNT_MANAGER_REPORT = 'audit-Cycle-Count-manager-report',
  AUDIT_CYCLE_COUNT_MANAGER_PROGRESS_REPORT = 'audit-Cycle-Count-manager-Progress-report',
  AUDIT_CYCLE_COUNT_MANAGER_EXPORT = 'audit-Cycle-Count-manager-export',

  VARIANCE_REPORT_APPROVAL = 'variance-report/Approval',
  VARIANCE_REPORT_DETAIL = 'variance-report-details',
  UX_VARIANCE_REPORT_ACTION_TYPE = 'ux/variance-report/action-type',
  WAREHOUSE_STOCK_TAKE_INITIATION_LIST = 'warehouse-stock-take-initiation',
  WAREHOUSE_STOCK_TAKE_EXPORT = 'warehouse-stock-take-initiation-export',
  WAREHOUSE_STOCK_TAKE_INITIATION_SCHEDULED_DATE = 'ux/warehouse-schedule-dates',

  WAREHOUSE_STOCK_TAKES = 'warehouse-stock-takes',
  WAREHOUSE_STOCK_TAKES_DETAILS = 'warehouse-stock-takes/details',
  STOCK_MOVEMENT = 'stock-movement',

  AUDIT_CYCLE_COUNT_SERIALNUMBERS = 'audit-Cycle-Count-Item-SerialNumbers',
  WASTE_DISPOSAL_COLLECT = 'wastedisposal-collect',
  WASTE_DISPOSAL_COLLECT_EXPORT = 'wastedisposal-collect-export',
  WDREQUEST_ATTACHMENT_TYPE = 'ux/wdrequest-attachment-type',
  WAREHOUSE_STOCK_TAKES_ITEMS = 'warehouse-stock-takes-item',
  WAREHOUSE_STOCK_TAKES_SCAN = 'warehouse-stock-takes-scan',
  UX_WAREHOUSE_STOCK_TAKES_LOCATIONS = 'ux/warehouse-stock-takes/Warehouse-StockTake-locations',
  WAREHOUSE_STOCK_TAKES_ITERATION_PROCESS = 'warehouse-stock-takes-iteration-process',
  WAREHOUSE_STOCK_TAKES_ITEM_UPDATE = 'warehouse-stock-takes-item-update',
  WAREHOUSE_STOCK_TAKES_SERIAL_NUMBERS = 'warehouse-stock-takes-Item-SerialNumbers',
  CYCLE_COUNT_STOCK_SCANNED_SERIAL_NUMBER = 'cycle-count-stock-Scanned-serialnumbers',
  WASTE_DISPOSAL_DOCUMENTS = 'wastedisposal-documents',
  UX_SPECIAL_PROJECT = 'ux/special-project',
  UX_ITEMS_DISCOUNT = 'ux/items/discount',
  UX_ITEMS ='ux/items',
  CYCLE_COUNT_ITERATION_PROCESS = 'cycle-count-iteration-process',
  UX_REQUEST_ITEM_STATUS = 'ux/rtrrequest-itemstatus',
  UX_SUPPLIER_ADDRESS = 'ux/supplieraddress',
  FAULTY_GENERATE_BARCODE = 'orderreceipts/faulty-ganeratebarcode',
  RTR_REQUEST = 'rtr-request',
  RTR_REQUEST_EXPORT = 'rtr-request-export',
  RTR_INVENTORY_EXPORT = 'rfr-inventory-export',
  RTR_REQUEST_DETAILS = 'rtr-request-details',
  RETURN_REPAIR_DETAILS = 'return-repair-details',
  RTR_REQUEST_SCAN_ITEMS = 'rtr-request/scan-items',
  RTR_REQUEST_STOCK_DETAILS = 'rtr-request/stock-details',
  UX_RTRREQUESTDOCUMENT_TYPE = 'ux/rtrrequestdocument-type',
  PURCHASE_ORDERS_GET_FILE = 'purchaseorders/get-file',
  COUNTER_SALES_LIST = 'direct-sale-list',
  UX_STORAGE_LOCATION_TYPES = 'ux/storagelocation-types',
  UX_VARIANCE_REPORT = 'ux/variance-report',
  VARIANCE_REPORT_NEW_COUNT_DETAILS = 'Variance-Report-New-Count-details',
  VARIANCE_REPORT_NEW_COUNT_ITEMS_DETAILS = 'Variance-Report-New-Count-Item-details',
  SUPPLIER_RETURN_NEW_SERIAL_NUMBER  = 'supplierreturn/new-serial-number',
  UX_VARIANCE_REPORT_NEW_COUNT = 'ux/Variance-Report-New-Count',
  VARIANCE_REPORT_NEW_COUNT_SCAN = 'Variance-Report-New-Count-scan',
  VARIANCE_REPORT_NEW_COUNT = 'Variance-Report-New-Count',
  STORAGE_LOCATIONS_SAP = 'storagelocations/sap',
  STORAGE_LOCATION_STOCK_COLLECTION = 'storage-location/stockcollection',
  WAREHOUSEASSISTANT_WORKLIST = 'warehouseassistant-workList',
  WAREHOUSEASSISTANT_WORKLIST_EXPORT ='warehouseassistant-workList-export',
  WAREHOUSEASSISTANT_WORKLIST_SERIALNUMBER = 'warehouseassistant-workList/serialnumber',
  UX_WAREHOUSEASSISTANT_WORKLIST = 'ux/warehouseassistant-workList',
  UX_FAULTYWORKLIST_ACTIONSTATUS = 'ux/faultyworklist-actionstatus',
  UX_FAULTYWORKLIST_STATUS = 'ux/faultyworklist-status',
  STOCK_MAINTENANCE_MANUALS = 'stock-maintenance-manuals',

  PACKERJOBS_DETAILS = 'packerjobs/details',
  PACKERJOBS_ITEM_DETAILS = 'packerjobs/item-details',
  UX_OVERRIDEREASONS = 'ux/OverrideReasons',
  PICKERJOBS_SCAN_ITEM_DETAILS = 'pickerjobs/Scan-Item-details',
  TRANSFER_REQUEST_PACKING_JOB = 'Transfer-Request-Packing-job/item-details',

  PICKEDJOBS_DETAILS = 'pickedjobs/details',
  PICKEDJOBS_SCAN_ITEM_DETAILS = 'pickedjobs/Scan-Item-details',
  PICKEDJOBS_JOB_ASSIGN = "pickedjobs/job-assign",
  PICKEDJOBS_SCAN = "pickedjobs/scan",

  DISCREPANCY = 'Discrepancy',
  DISCREPANCY_ITEM_DETAILS = 'Discrepancy/item-details',
  UX_STOCK_DISCREPANCY_REASONS = 'ux/Stock-Discrepancy-Reasons',
  STOCK_MOVEMENT_STOCKONHAND = 'stock-movement-StockOnHand',
  STOCK_MOVEMENT_STOCKONHAND_DETAILS = 'stock-movement-StockOnHand-details',
  STOCK_MOVEMENT_SUMMARY = 'stock-movement-summary',
  STOCK_MOVEMENT_AGEING = 'stock-movement-ageing',
  SAP_MOVEMENT  = 'stock-movement-LogList',
  SAP_MOVEMENT_DETAIL  = 'stock-movement-log-details',
  REPUSH = 'stock-movement-log-repush',
  RETURN_REPAIR_REQUEST = 'return-repair-request',
  RETURN_REPAIR_ITEMDETAILS = 'return-repair-itemdetails',
  RETURN_REQUEST_WAREHOUSE_DETAILS = 'rtr-request/warehousequote-details',
  QUOTE_GENERATE = 'quote-generate',
  RFR_QUOTATION_GENERATE = 'rtr-request-quotation-generate',
  UX_RTR_REQUEST_ITEMCODE = 'ux/rtr-request/itemcode',
  RTR_REQUEST_SERIALNUMBER_DETAILS = 'rtr-request/serialnumber-details',
  RETURN_REPAIR_DOCUMENTS = 'return-repair-documents',
  RTR_REQUEST_DOCUMENTS_DETAILS = 'rtr-request/documents-details',
  RTR_REQUEST_QUOTE_DETAILS = 'rtr-request/quote-details',
  RTR_REQUEST_FINAL_QUOTE_DETAILS = 'rtr-request-final-quote-details',
  UX_RTRREQUESTQUOTEAPPROVAL_TYPE = 'ux/rtrrequestquoteapproval-type',
  QUOTE_APPROVAL = 'quote-approval',
  RTR_REQUEST_DOCUMENTS = 'rtr-request-documents',
  UX_STOCK_DSCREPANCY_STATUS = 'ux/stock-discrepancy-status',
  UX_STOCK_DISCREPANCY_DOCUMENT_TYPES = 'ux/Stock-Discrepancy-DocumentTypes',
  DISCREPANCY_INVESTIGATION_POST = 'Discrepancy-investigation-post',
  DISCREPANCY_CONSUMABLE_ITEM_DETAILS = 'Discrepancy/consumable-item-details',
  DISCREPANCY_CONSUMABLE_ITEM_INVESTIGATION_POST = 'Discrepancy-consumable-item-investigation-post',
  PACKING_DASHBOARD_LIST = 'PackingDashboard-List',
  PACKING_DASHBOARD_EXPORT = 'PackingDashboard-export',
  UX_RECEIVINGID = 'ux/receivingid',
  UX_RECEIVING_REFERENCENUMBER = 'ux/Receiving-referencenumber',
  UX_RECEIVINGBARCODE = 'ux/receivingBarcode',
  UX_JOBORDERSTATUS = 'ux/joborderstatus',
  UI_WAREHOUSES = 'ux/warehouses',
  UX_DISTRICTS_BY_USER ='ux/district-by-user',
  PACKINGDASHBOARD_DETAILS = 'PackingDashboard-details',
  REFERENCENUMBER = 'ReferenceNumber',
  INTTECH_TRANSFER = 'inttech-transfer',
  // INTTECH_TRANSFER_DETAILS = 'inttech-transfer-details',
  INTTECH_TRANSFER_REQUESTLOCATION_NAME = 'inttech-transfer-requestlocation-name',
  UX_INTTECH_TRANSFER_LOCATIONS = 'ux/inttech-transfer/locations',
  CUSTOMER_ORDER_INTTECH_TRANSFER_DETAILS = 'customer-order/inttech-transfer-details',
  CUSTOMER_ORDER_INTTECH_TRANSFER = 'customer-order/inttech-transfer',
  TECHNICIAN_STOCK_TAKE = 'TechnicianStockTake',
  TECHNICIAN_STOCK_TAKE_EXPORT = 'TechnicianStockTake-export',
  TECHNICIAN_STOCK_TAKE_VALIDATE_QRCODE = 'TechnicianStockTake-Validate-qrcode',
  TECHNICIAN_STOCK_TAKE_STOCKLIST = 'TechnicianStockTake-stocklist',
  TECHNICIAN_STOCK_TAKE_STOCK_DETAILS = 'TechnicianStockTake-stock-Details',
  TECHNICIAN_STOCK_TAKE_SCANNED_ITEM_POST = 'TechnicianStockTake-scanned-item-post',
  TECHNICIAN_STOCK_TAKE_ITERATION_UPDATE = 'TechnicianStockTake-iteration-update',
  GOODS_RETURN_ITEM_SERIALNUMBERS = 'goods-Return-Item-SerialNumbers',
  TECHNICIAN_STOCK_TAKE_LOCATION_REPORT = 'TechnicianStockTake-location-report',
  TECHICIAN_STOCK_TAKE_REPORT_SERIALNUMBER = 'TechnicianStockTake-report-serialnumber',
  TECHNICIAN_STOCK_TAKE_ITERATION_REPORT = 'TechnicianStockTake-iteration-report',
  TECHNICIAN_STOCK_TAKE_ITEM_DETAIL_REPORT = 'TechnicianStockTake-Item-detail-report',
  UX_INVENTORY_ROLES = 'ux/inventory-roles',
  STOCK_BALANCE_COUNT = 'stock-balance-count',
  SAVE_STOCK_MAINTENANCE_PRODUCT_WAREHOUSE = 'stock-maintenance/product-warehouse',
  SAVE_STOCK_MAINTENANCE_PRODUCT_THRESHOLD = 'stock-maintenance/product-threshold',
  UX_MODULES = 'ux/modules',
  UX_PICKEDJOBS_INVENTORYSTAFF = 'ux/pickedjobs/inventoryStaff',

  UX_TECH_STOCK_TAKE_VARIANCE_REPORT_ITEM = 'ux/tech-stock-take-variance-report-item',
  TECH_STOCK_TAKE_VARIANCE_REPORT_INVESTIGATION = 'tech-stock-take-variance-report-investigation',
  UX_TECH_STOCK_TAKE_VARIANCE_REPORT_SERIAL_NUMBER = 'ux/tech-stock-take-variance-report-serialnumber',
  UX_TECH_STOCK_TAKE_VARIANCE_REPORT_BOM_SERIAL_NUMBER = 'ux/tech-stock-take-variance-report-bom-serialnumber',
  TECH_STOCK_TAKE_VARIANCE_REPORT_REVIEW = 'tech-stock-take-variance-report-review',
  UX_SUBAREA = 'ux/sub-area',
  STOCK_MANAGEMENT_EXPORT = 'stock-management-export',
  STOCK_MANAGEMENT_SERIAL_NUMBER_EXPORT = 'stock-management-serialnumber-export',
  // DEALER_ITEM_PRICING_CONFIG = 'dealer-item-pricing-config',
  STOCK_MAINTENANCE_PRODUCT_WAREHOUSE_CONSOLIDATE = 'stock-maintenance-product-warehouse/consolidate',
  STOCK_MAINTENANCE_DOCUMENTS ='stock-maintenance-support-documents',
  DEALER_ITEM_PRICING_CONFIG = 'dealer-item-pricing-config',
  // DEALER_ITEM_PRICING_CONFIG  = 'dealer-item-pricing-config',
  UX_BIN_LOCATION = 'ux/bin-location',
  STOCK_LOOKUP = 'stock-lookup',
  STOCK_CODE_VALIDATE_WAREHOUSELIST = 'StockCodeValidateWarehouseList',

  RECEIVING_NEW = 'receiving-new',
  RECEIVING_NEW_ITEMS = 'receiving-new-items',
  RECEIVING_NEW_DETAILS = 'receiving-new-details',
  RECEIVING_NEW_SUBMIT = 'receiving-new-submit',

  BIN_LOCATION_VALIDATE = 'bin-location-validate',
  STOCKBIN_MOVEMENT_BINDETAILS = 'stockbinmovement/BinDetails',
  STOCKBIN_MOVEMENT_SCAN_ITEMDETAILS_BINDETAILS = 'stockbinmovement/ScanItemDetailBinDetails',
  STOCK_BIN_MOVEMOVEMENT = 'stockbinmovement',
  UX_RECEIVING_FROM_TYPES = 'ux/received-from-types',
  UX_TECHNICIAN_STOCK_COLLECTION= 'ux/technician-stock-collection',

  TASK_LIST = 'TaskList',
  TASK_LIST_EXPORT = 'TaskList-export-Excel',
  STOCKBIN_MOVEMOVEMENT_TASKLIST_INSERT = 'stockbinmovement/tasklist-insert',
  REQUISITION_INITIATOR_CONFIGURATION = 'requisition-initiator-config',
  REQUISITION_INITIATOR_CONFIGURATION_EXCEL = 'requisition-Initiator-export-Excel',
  REQUISITION_INITIATOR_CONFIGURATION_EXPORT_EXCEL   = 'requisition-initiator-config-export-Excel',
  UX_STORAGE_LOCATION_PREFIX = 'ux/storage-location-prefix',
  REQUISITION_CREATION_VALIDATION = 'requisition-creation-validation',
  STOCK_MAINTENANCE_EXPORT = 'stock-maintenance-export',
  PURCHASE_ORDER_EXPORT  = 'purchaseorders-export',
  RFR_INVENTORY = 'rfr-inventory',
  RFR_INVENTORY_DETAILS = 'rfr-inventory/details',
  UX_SUPPLIER_RETURN_PURCHASE_ORDER = 'ux/supplierreturn-purchase-order',
  UX_MOVEMENTTYPE = 'ux/movementtype',
  RFR_INVENTORY_ITEM_WARRANTY_STATUS = 'rfr-inventory-item-warranty-status',
  UX_STOCK_LOOKUP_STORAGE_LOCATION = 'ux/stock-lookup-storage-location',

  RADIO_REMOVAL_RECEIVING = 'radio-removal-receiving',
  UX_RADIO_REMOVAL_RECEIVING_USERS = 'ux/radio-removal-receiving-users',
  RADIO_REMOVAL_RECEIVING_ITEMS = 'radio-removal-receiving-items',
  RADIO_REMOVAL_RECEIVING_DETAILS = 'radio-removal-receiving-details',
  RADIO_REMOVAL_RECEIVING_SAVE_AS_DRAFT = 'radio-removal-receiving/save-as-draft',
  RADIO_REMOVAL_RECEIVING_SUBMIT = 'radio-removal-receiving-submit',
  RADIO_REMOVAL_RECEIVING_CUSTOMER_DETAILS = 'radio-removal-receiving-customer-details',
  RADIO_REMOVEL_EXPORT='radio-removal-receiving-export',

  TECH_AUDIT_CYCLE_COUNT_JOB = 'TechAuditCycleCountJob',
  TECH_AUDIT_CYCLE_COUNT_JOB_DETAILS_LIST = 'TechAuditCycleCountJob-detail-list',
  TECH_AUDIT_CYCLE_COUNT_JOB_STOCK_DETAILS = 'TechAuditCycleCountJob-stock-Details',
  TECH_AUDIT_CYCLE_COUNT_JOB_SCANNED_ITEM_POST = 'TechAuditCycleCountJob-scanned-item-post',
  TECH_AUDIT_CYCLE_COUNT_JOB_ITERATION_UPDATE = 'TechAuditCycleCountJob-iteration-update',
  TECH_AUDIT_CYCLE_COUNT_JOB_NEW_ITEM_POST = 'TechAuditCycleCountJob-new-item-post',
  TECH_AUDIT_CYCLE_COUNT_JOB_ITEM_SERIAL_NUMBERS = 'TechAuditCycleCountJob-Item-SerialNumbers',

  UX_MODULE_NAVIGATION_ROLES = 'ux/modulenavigationroles',

  TRANSFER_REQUEST_PICKING_JOB_ASSIGN = 'Transfer-Request-picking-job/assign',
  TRANSFER_REQUEST_PICKING_JOB_DETAILS = 'Transfer-Request-picking-job/details',
  TRANSFER_REQUEST_PICKING_JOB_ITEM_DETAILS = 'Transfer-Request-picking-job/item-details',
  TRANSFER_REQUEST_PICKING_JOB_SCAN = 'Transfer-Request-picking-job/scan',
  TRANSFER_REQUEST_PICKING_JOB_MANAGER_OVERRIDE = 'Transfer-Request-picking-job/manager-override',

  TRANSFER_REQUEST_PACKING_JOB_ASSIGN = 'Transfer-Request-packing-job/assign',
  TRANSFER_REQUEST_RECEIVING = 'transfer-request-receiving',
  UX_TRANSFER_REQUEST_RECEIVING = 'ux/transfer-request-receiving',
  TRANSFER_REQUEST_RECEIVING_ITEMS = 'transfer-request-receiving-items',
  TRANSFER_REQUEST_RECEIVING_DETAILS = 'transfer-request-receiving-details',
  TRANSFER_REQUEST_RECEIVING_SUBMIT = 'transfer-request-receiving-submit',
  STOCK_MANAGEMENT_LOCATIONBIN_STOCK_DETAILS = 'stock-management/Location-bin-Stock-Details',
  STOCK_MANAGEMENT_LOCATIONBIN_STOCK_LIST = 'stock-management-location-stock-List',
  RTR_REQUEST_TAM_FINAL_QUOTE_DETAIL = 'rtr-request-tam-final-quote-details',
  RTR_REQUEST_TAM_FINAL_QUOTE_GENERATE = 'rtr-request-quotation-generate',
  UX_RTR_REQUEST_TAM_FINAL_QUOTE_STATUS = 'ux/rtr-request-quote-status',
  RTR_REQUEST_TAM_FINAL_QUOTE_ACCEPT = 'rtr-request-final-quote-accept',
  RTR_REQUEST_TAM_FINAL_QUOTE_CALL_BACK = 'rtr-requestfinal-quote-call-back',
  RTR_REQUEST_TAM_FINAL_QUOTE_DECLINE = 'rtr-request-final-quote-decline',
  REQUISITION_DETAILED_ORDERING_LIST = 'requisition/detailed-reordering-list',

  SUPPLIER_RETURN_REQUEST_NEW_PO_DETAILS = 'supplier-return-request-new-po-details',
  SUPPLIER_RETURN_REQUEST_NEW_SERIAL_NUMBER_SCAN = 'supplier-return-request-new-serial-number-scan',
  SUPPLIER_RETURN_REQUEST_NEW = 'supplier-return-request-new',
  SUPPLIER_RETURN_REQUEST_NEW_SAVE = 'supplier-return-request-new-save',
  SUPPLIER_ADDRESS_NEW = 'supplieraddress-new',
  SUPPLIER_RETURN_REQUEST_NEW_VIEW_DETAILS = 'supplier-return-request-new-view-details',
  WAREHOUSE_STOCK_TAKES_ITEM_DETAILS_LIST = 'warehouse-stock-takes-Item-Details-list',
  WAREHOUSE_STOCK_TAKE_ITEMS_BIN_DETAILS = 'warehouse-stock-takes-items-bin-details',
  WAREHOUSE_STOCK_TAKES_NEXT_ITEMS_DETAILS = 'warehouse-stock-takes-Next-items-details',
  WAREHOUSE_STOCK_TAKES_INPROGRESS_ITEMS = 'warehouse-stock-takes-InProgress-Items',
  AUDIT_CYCLE_COUNT_ITEM_DETAILS_LIST = 'audit-Cycle-Count-item-details-list',
  AUDIT_CYCLE_COUNT_INITIATED_LIST = 'audit-Cycle-Count-initiated-list',
  RTR_REQUEST_ITEMS ='rtr-request-items',
  RTR_REQUEST_ITEMS_DETAILS  = 'rtr-request-itemdetails',
  AUDIT_CYCLE_COUNT_ITEMS_BIN_DETAILS = 'audit-Cycle-Count-items-bin-details',

  PICKING_DASHBOARD_EXPORT = 'picking-dashboard-export',
  PICKING_ORDERS_EXPORT = 'picking-dashboard/picking-orders-export',
  PICKED_ORDERS_EXPORT = 'picking-dashboard/picked-orders-export',
  SCHEDULED_CUSTOMER_ORDERS_EXPORT = 'picking-dashboard/scheduled-customer-orders-export',
  DASHBOARD_TECHNICIAN_ORDERS_EXPORT = 'picking-dashboard/technician-orders-export',
  DASHBOARD_STOCK_ORDER_EXPORT = 'inter-branch-stockorder-dashboard-report-export',
  DASHBOARD_ACCEPTED_CUSTOMER_EXPORT = 'picking-dashboard/accepted-customer-orders-export',
  UX_RTR_CALL_INITIATION ='ux/rtr-request/call-initiation',
  AUDIT_CYCLE_COUNT_INPROGRESS_ITEMS = 'audit-Cycle-Count-InProgress-Items',
  CYCLE_COUNT_INPROGRESS_ITEMS= 'cycle-count-InProgress-Items',
  CYCLE_COUNT_ITEM_DETAIL = 'cycle-count-item-details-list',
  AUDIT_CYCLE_COUNT_NEW_ITEMS = 'audit-Cycle-Count-new-items',
  AUDIT_CYCLE_COUNT_NEW_ITEM_POST = 'audit-Cycle-Count-new-item-post',
  WAREHOUSE_STOCK_TAKES_MANAGER_REPORT = 'warehouse-stock-takes-manager-report',
  WAREHOUSE_STOCK_TAKES_MANAGER_PROGRESS_REPORT ='warehouse-stock-takes-manager-Progress-report',
  AUDIT_CYCLE_COUNT_CONFIG_DETAILS= 'audit-Cycle-Count-config-details',

  EXCLUSION_LIST_DETAILS = 'exclusion-list-Details',
  STOCK_SELLING_PRICE_EXPORT  = 'stock/selling-price-export',
  VARIANCE_ESCALATION_EXPORT  ='variance-escalation-export',
  WAREHOUSES_EXPORT   = 'warehouses-export',
  STORAGELOCATIONS_EXPORT = 'storagelocations-export',
  VARIANCE_REPORT_EXPORT = 'variance-report-export',
  STOCK_MOVEMENT_STOCKONHAND_FILTER = 'stock-movement-StockOnHand/filter',
  STOCK_MOVEMENT_SUMMARY_FILTER = 'stock-movement-summary/filter',
  STOCK_MOVEMENT_FILTER = 'stock-movement/filter',
  STOCK_MOVEMENT_AGEING_FILTER = 'stock-movement-ageing/filter',
  RADIOREMOVAL_VALIDATE_ONCUSTOMER = 'radioremoval-validate-oncustomer',
  SELLING_PRICE_EXPORT='Dealerstock/selling-price-export',
  RECEVING_EXPORT='receiving-export',
  TECHNICAL_ORDER_RECEVING_EXPORT='orderreceipts/technician-export',
  ORDER_RECEIPTS_INTRANSIT_EXPORT='orderreceipts/intransit-export',
  SUPPLIER_RETURN_EXPORT='orderreceipts/supplier-return-export',
  TRANSFER_REQUEST_RECEIVING_EXPORT='transfer-request-receiving-export',
  SUPPLIER_RETURN_TO_EXPORT='supplierreturn-export',
  STOCK_STAKE_EXPORT='warehouse-stock-takes-list-export',
  TECH_STACK_LIST_EXPORT='TechnicianStockTakeInitiation-list-export',
  TECHNICIAN_STORAGE_LOCATION  = 'storagelocations/Technician-Storage-filter',
  SUPPLIER_RETURN_GENERATE_PDF_DETAIL = 'supplier-returngenerate-pdf-detail',
  SUPPLIER_RETURN_GENERATE_PDF = 'supplier-return-generate-pdf',
  PENDING_EMPLOYEE  = 'employee-pending-jobs',
  COUNTER_SALE_STOCK_ORDER_COLLECTIONS = 'Counter-Sale-Stock-Order-Collections',
  COUNTER_SALE_STOCK_ORDER_COLLECTIONS_EXPORT = "Counter-Sale-Stock-Order-Collections-export",
  COUNTER_SALE_STOCK_ORDER_COLLECTIONS_STOCK_DETAILS = 'Counter-Sale-Stock-Order-Collections-StockDetails',
  COUNTER_SALE_STOCK_ORDER_COLLECTIONS_DETAILS  = 'Counter-Sale-Stock-Order-Collections-details',
  COUNTER_SALE_STOCK_ORDER_COLLECTIONS_DETAILS_SAVE = 'Counter-Sale-Stock-Order-Collections-save',
  UX_COUNTRY = 'ux/Country',
  UX_STOCK_ORDER_QUERY_APPROVER = 'ux/stock-order-query-approver',
  UX_SUPPLIER_DROPDOWN = 'suppliers/searchbyserialnumber'
}

enum RQNStatus {
  OPEN = 'Open',
  INVENTORY_MANAGER_APPROVAL = 'Inventory Manager Approval Pending',
  CANCELLED = 'Cancelled',
  APPROVED = 'Approved',
  REJECTED = 'Rejected',
  PENDING = 'Pending',
  SUBMITTED = 'Submitted'
}
enum InterBranchStockOrderStatus {
  CREATED = 'Created',
  CANCELLED = 'Cancelled',
  INITIATED = 'Initiated',
  INPROGRESS = 'In Progress',
  SUBMITTED = 'Submitted',
  RECEIVED = 'Received',
  APPROVED = 'Approved',
  PARTIALLYAPPROVED = 'Partially Approved',
  REJECTED = 'Rejected',
  MODIFIED = 'Modified'


}

enum DocumentTypes {
  SUPPLIERS_INVOICE = "Supplier Invoice"
}

enum OrderTypes {
  FAULTY = "10",
  FAULTY_NAME = "Faulty",
  NEW = "11",
  REPLACEMENT = "12",
  RETURN = "13",
  INTRANSIT = "15",
  CUSTOMER = "17",
  TECHNICIAN = "18",
  GOODSRETURN = "19"
}

enum INVENTORY_COMPONENT {
  STOCK_AND_WAREHOUSE_MANAGEMENT = "Stock & Warehouse Management",
  STOCK_MAINTENANCE = "Stock Maintenance",
  STOCK_MANAGEMENT = "Stock Management",
  STOCK_TABLE_SELLING_PRICE = "Stock Table Selling Price",
  DEALER_STOCK_TABLE_SELLING_PRICE = "Dealer Stock Table Selling Price",
  DEALER_STOCK_ORDER_COLLECTION='Dealer Stock Order Collection',
  WAREHOUSE_MANAGEMENT = "Warehouse Management",
  KIT_CONFIGURATION = "Kit Configuration",
  ORDERING = "Ordering",
  REQUISITION = "Requisition",
  RETURN_FOR_REPAIR_REQUEST="Return For Repair Request",
  RETURN_FOR_REPAIR_VERIFICATION ="Return For Repair Verification",
  REQUISITION_APPROVAL = "Requisition Approval",
  EXCLUSION_LIST = "Exclusion List",
  RECEIVING = "Receiving",
  INVENTORY = 'Inventory',
  PICKER_AND_PACKERS = "Picker & Packers",
  JOB_SELECTION = "Job Selection",
  TRANSFER_ORDERS = "Transfer Orders",
  INTER_BRANCH_TRANSFER_REQUEST = "Inter Branch Transfer Request",
  INTER_BRANCH_TRANSFER_APPROVAL = "Inter Branch Transfer Approval",
  INTER_TECHNICIAN_REQUEST = "Inter Technician Request",
  INTER_TECHNICIAN_ORDER = "Inter Technician Order",
  STOCK_RETURN = "Stock Return",
  SUPPLIER_RETURN_REQUESTS = "Supplier Return Requests",
  VARIANCE_ESCALATION = "Variance Escalation",
  STOCK_TAKE = "Stock Take",
  STOCK_TAKE_SCHEDULING = "Stock Take Scheduling",
  STAKE_TAKE_INITIATION = "Stake Take Initiation",
  WAREHOUSE_STOCK_TAKE_MANAGER = "Warehouse Stock Take Manager",
  WASTE_DISPOSAL = "Waste Disposal",
  COMPANY_CONFIGURATION = "Company Configuration",
  WASTE_DISPOSAL_REQUEST = "Waste Disposal Request",
  WASTE_DISPOSAL_REQUEST_APPROVAL = "Waste Disposal Request Approval",
  WASTE_DISPOSAL_COLLECTION = "Waste Disposal Collection",
  PICKING_DASHBOARD = "Picking Dashboard",
  DAILY_STAGING_BAY_REPORT = "Daily Staging Bay Report",
  GOODS_RETURN = "Goods Return",
  STOCK_ADJUSTMENT = "Stock Adjustment",
  STOCK_MOVEMENT = "Stock Movement",
  WAREHOUSE_ASSISTANT = "Warehouse Assistant",
  PACKING_DASHBOARD = "Packing Dashboard",
  PURCHASE_ORDER='Purchase Order',
  STOCK_DISCREPANCY = "Stock Discrepancy",
  CONFIGURATION = "Configuration",
  CYCLE_COUNT_CONFIGURATION="Cycle Count Configuration",
  CYCLE_COUNT_SCHEDULEING="Cycle Count Scheduling",
  CYCLE_COUNT_DISABLE_PERIOD = "Cycle Count Disable Period",
  CYCLE_COUNT_STARTING_DATE = "Cycle Count Starting Date",
  CYCLE_COUNT_STAFF="Cycle Count - Staff",
  CYCLE_COUNT_MANAGER="Cycle Count - Manager",
  AUDIT_CYCLE_CONFIGURATION="Audit Cycle Configuration",
  AUDIT_CYCLE_COUNT="Audit Cycle Count",
  AUDIT_CYCLE_COUNT_MANAGER="Audit Cycle Count Manager",
  STOCK_LIMIT_CONFIG ='Stock Limit Config',
  VARIANCE_REPORT="Variance Report",
  REQUISITION_INITIATOR_CONFIGURATION='Requisition Initiator Configuration'
}
export { InventoryModuleApiSuffixModels, RQNStatus, InterBranchStockOrderStatus, DocumentTypes, OrderTypes ,INVENTORY_COMPONENT};

